import React, {useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartPaymentInputs from "./groheCartPaymentInputs";
import WithInputValidations from "../../../hocs/withInputValidations";
import store from "../../../../../store";
import {restorePaymentInfo} from "../../../../../actions/paymentFunctions";
import GroheCartBackButton from "../groheCartBackButton";
import Misc from "../../../../../misc/misc";
import Analytics from "../../../../../analytics";
import {getAnalyticsEcommerceValues} from "../../../../../analyticsEcommerceParams";


const GroheCartPayment = (props) => {

  const {isMobile, history, cardInfo, restorePaymentInfo} = props;
  const [defaultValues] = useState(cardInfo);

  const disabled = !cardInfo.cardNumber;

  const backButtonClick = () => {
    restorePaymentInfo({
      cardInfo: defaultValues
    });
    history.push(ROUTES.cartBilling);
  };

  const confirmButtonClick = async (updateInputValidations) => {

    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("add_payment_info", {currency, value, items,
      coupon: "", // "SUMMER_FUN" // we are not using that
      payment_type: "Credit Card",
    });

    await updateInputValidations();
    const errors = store.getState().paymentState.cardErrors;
    if (Misc.hasErrors(errors)) {
      return false
    }
    history.push(ROUTES.cartBilling);
  };

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => {

        const stickyFooterButtons = [
          {
            translate: "buttons.back",
            classes: "look-button--secondary",
            onClick: () => {
              history.push(ROUTES.cartBilling);
            }
          },
          {
            translate: "grohe.cart.payment.submitButton",
            classes: "look-button--blue gc-sticky__button--60",
            onClick: () => confirmButtonClick(updateInputValidations),
            disabled
          },
        ];

        return (
          <div className="gc">
            <div className="gc-body">
              <GroheCartHeaderCommon title="grohe.cart.payment.title" subTitle="grohe.cart.payment.subTitle"/>
              <GroheCartPaymentInputs inputsValidated={inputsValidated}/>
              {isMobile ? null : (
                <div className="gc-footer">
                  <div className="gc-form__submit-right">
                    <GroheCartBackButton backButtonClick={backButtonClick}/>
                    <Button className="look-button look-button--blue nowrap"
                            disabled={disabled}
                            onClick={() => confirmButtonClick(updateInputValidations)}>
                      <FormattedMessage id="grohe.cart.payment.submitButton"/>
                    </Button>
                  </div>
                </div>
              )}
              {isMobile ? <div className="gc-spacer"/> : null}
            </div>
            {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
          </div>
        )
      }}
    </WithInputValidations>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {cardInfo} = store.paymentState;

  return {
    isMobile,
    cardInfo,
  };
};

const mapDispatchToProps = {
  restorePaymentInfo
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartPayment))
